import React, { useCallback } from "react";
import { ChakraProps, useToast } from "@chakra-ui/react";
import AsyncSelect from "./AsyncSelect";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import { getAmbience } from "../../api/sounds/sounds";

interface SelectAmbienceProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectAmbience: React.FC<SelectAmbienceProps> = ({ color, value, setValue, ...chakraProps }) => {
  const toast = useToast();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      let ambience: string[] = [];

      try {
        ambience = await getAmbience(searchQuery);
      } catch (error) {
        toast({
          title: "API error occurred",
          description: (error as Error).message,
          status: "error",
        });
      }

      return ambience.map((fileName) => [fileName, fileName]);
    },
    [toast]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"Ambience"}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectAmbience;
